<div class="{{ navbarClass }}">
    <div class="container">
        <nav class="navbar navbar-expand-md navbar-light">
            <a class="navbar-brand" routerLink="/" aria-label="Webstazy One — home">
                <img class="webstazyLogo" src="assets/img/webstazy.png" alt="Webstazy One" />
                <!-- <h3>Webstay One</h3> -->
            </a>

            <button class="navbar-toggler" type="button" (click)="toggleMenu()"
                aria-controls="navbarSupportedContent" [attr.aria-expanded]="menuOpen"
                [attr.aria-label]="menuOpen ? 'Close navigation' : 'Open navigation'">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse spaceFor" id="navbarSupportedContent" [class.show]="menuOpen">
                <ul class="navbar-nav" (click)="onNavClick($event)">
                    <li class="nav-item">
                        <a routerLink="/" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">Home</a>
                        <!-- <i class='bx bx-chevron-down'></i> -->
                        <!-- <ul class="dropdown-menu">
                            <li class="nav-item"><a href="#" class="nav-link">With Animation Home <i class='bx bx-chevron-right'></i></a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item"><a routerLink="/" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home One (IT Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/home-2" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Two (IT Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/home-3" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Three (IT Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/home-4" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Four (SaaS Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/home-5" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Five (Chatbot)</a></li>

                                    <li class="nav-item"><a routerLink="/home-6" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Six (Chatbot)</a></li>

                                    <li class="nav-item"><a routerLink="/home-7" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Seven (Chatbot)</a></li>
                                </ul>
                            </li>

                            <li class="nav-item"><a href="#" class="nav-link">Without Animation Home <i class='bx bx-chevron-right'></i></a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item"><a routerLink="/without-animation-home-1" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home One (IT Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/without-animation-home-2" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Two (IT Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/without-animation-home-3" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Three (IT Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/without-animation-home-4" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Four (SaaS Startup)</a></li>

                                    <li class="nav-item"><a routerLink="/without-animation-home-5" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Five (Chatbot)</a></li>

                                    <li class="nav-item"><a routerLink="/without-animation-home-6" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Six (Chatbot)</a></li>

                                    <li class="nav-item"><a routerLink="/without-animation-home-7" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home Seven (Chatbot)</a></li>
                                </ul>
                            </li>
                        </ul>  -->
                    </li>

                    <!-- <li class="nav-item"><a
                            routerLink="/about" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">About <i class='bx bx-chevron-down'></i></a>

                        <ul class="dropdown-menu">

                            <li class="nav-item"><a
                                    routerLink="/team" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Team</a></li>

                            <li class="nav-item" data-toggle="collapse"><a pageScroll href="#clientele-title">Clientele</a></li>


                            <li class="nav-item"><a pageScroll href="#Partnerships-title"
                                   class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Partnreships</a></li>

                            <li class="nav-item"><a
                                    routerLink="/pressroom" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Pressroom</a></li>
                        </ul>
                    </li> -->

                    <li class="nav-item">
                        <a routerLink="/services" class="nav-link" [class.active]="servicesActive"
                            [attr.aria-current]="servicesActive ? 'page' : null">Services <i class="bx bx-chevron-down" aria-hidden="true"></i></a>
                        <!-- <ul class="dropdown-menu">
                            <li class="nav-item"><a href="#" class="nav-link">Features <i
                                        class='bx bx-chevron-right'></i></a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item"><a
                                            routerLink="/services-1" class="nav-link" routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">Services One</a></li>

                                    <li class="nav-item"><a
                                            routerLink="/services-2" class="nav-link" routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">Services Two</a></li>

                                    <li class="nav-item"><a
                                            routerLink="/services-details" class="nav-link" routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">Service Details</a></li>
                                </ul>
                            </li>

                            <li class="nav-item"><a href="#" class="nav-link">Features <i
                                        class='bx bx-chevron-right'></i></a>
                                <ul class="dropdown-menu">
                                    <li class="nav-item"><a
                                            routerLink="/features-1" class="nav-link" routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">Features Style One</a></li>

                                    <li class="nav-item"><a
                                            routerLink="/features-2" class="nav-link" routerLinkActive="active"
                                            [routerLinkActiveOptions]="{exact: true}">Features Style Two</a></li>
                                </ul>
                            </li>

                            <li class="nav-item"><a
                                    routerLink="/team" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Team</a></li>

                            <li class="nav-item"><a
                                    routerLink="/log-in" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Log In</a></li>

                            <li class="nav-item"><a
                                    routerLink="/sign-up" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Sign Up</a></li>

                            <li class="nav-item"><a
                                    routerLink="/faq" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">FAQ</a></li>

                            <li class="nav-item"><a
                                    routerLink="/error" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">404 Error</a></li>
                        </ul> -->

                        <ul class="dropdown-menu">
                            <li class="nav-item">
                                <a routerLink="/service-web-design" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }">Web Design &amp; Development</a>
                            </li>

                            <li class="nav-item">
                                <a routerLink="/service-mobile-application" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }">Mobile Application Development</a>
                                <!-- <i class='bx bx-chevron-right'></i> -->
                                <!-- <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Platforms and aggregate  networks</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Android app development </a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Ios app development</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Hybrid app development</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">AR/VR App development</a></li>
                                    </ul> -->
                            </li>

                            <li class="nav-item">
                                <a routerLink="/service-custom-cloudbased-sol" class="nav-link"
                                    routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Custom Cloud
                                    Based Solutions</a>
                                <!-- <i class='bx bx-chevron-right'></i> -->

                                <!-- <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Point of sales </a></li>
                                    </ul> -->
                            </li>

                            <li class="nav-item">
                                <a routerLink="/service-digital-media" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }">Digital Media Marketing</a>
                                <!-- <i class='bx bx-chevron-right'></i> -->
                                <!-- <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Social media marketing</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Search Engine Optimization</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Viral marketing</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Inbound marketing</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Branding </a></li>
                                    </ul> -->
                            </li>

                            <li class="nav-item">
                                <a routerLink="/service-digital-infrastructure" class="nav-link"
                                    routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Digital
                                    Infrastructure &amp; Business
                                    Process Management</a>
                                <!-- <i class='bx bx-chevron-right'></i> -->

                                <!-- <ul class="dropdown-menu">
                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Network management and security</a></li>

                                        <li class="nav-item"><a routerLink="/services" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">IT Services</a></li>
                                    </ul> -->
                            </li>
                        </ul>
                    </li>

                    <!-- <li class="nav-item"><a
                            routerLink="/pricing" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">Pricing</a></li> -->
                    <!--
                    <li class="nav-item"><a class="nav-link"
                            routerLinkActive="active" routerLink="/products"
                            [routerLinkActiveOptions]="{exact: true}">Products <i class='bx bx-chevron-down'></i></a>

                        <ul class="dropdown-menu">
                            <li class="nav-item"><a
                                    routerLink="/travel" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Travel</a></li>

                            <li class="nav-item"><a
                                    routerLink="/automative" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Automotive</a></li>

                            <li class="nav-item"><a
                                    routerLink="/social" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Social</a></li>
                        </ul>

                    </li> -->

                    <!-- <li class="nav-item">
                        <a href="#" class="nav-link">Blog <i class='bx bx-chevron-down'></i></a>
                        <ul class="dropdown-menu">
                            <li class="nav-item"><a
                                    routerLink="/blog-1" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Blog Grid</a></li>

                            <li class="nav-item"><a
                                    routerLink="/blog-2" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Blog Right Sidebar</a></li>

                            <li class="nav-item"><a
                                    routerLink="/blog-details" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">Blog Details</a></li>
                        </ul>
                    </li> -->
                    <!-- <li class="nav-item"><a
                            routerLink="/portafolio" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{exact: true}">Portfolio</a></li>

                            <li class="nav-item"><a
                                routerLink="/showcase" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}">Showcase</a></li>
                            -->
                    <li class="nav-item" [class.open]="venturesOpen" (focusout)="onVenturesFocusOut($event)">
                        <button type="button" class="nav-link nav-dropdown-toggle" [class.active]="venturesActive"
                            aria-controls="ventures-menu" [attr.aria-expanded]="venturesOpen"
                            (click)="venturesOpen = !venturesOpen" (keydown.escape)="venturesOpen = false">Ventures <i class="bx bx-chevron-down" aria-hidden="true"></i></button>
                        <ul class="dropdown-menu" id="ventures-menu">
                            <li class="nav-item">
                                <a routerLink="/ventures/fort-mart" class="nav-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }">Fort Mart</a>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/contact" class="nav-link" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }">Get in Touch</a>
                    </li>
                </ul>
                <!-- <div class="others-options">
                    <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot"></i>Get Started<span></span></a>
                    <a routerLink="/log-in" class="optional-btn"><i class="bx bx-log-in"></i>Log In<span></span></a>
                </div> -->
            </div>
        </nav>
    </div>
</div>
